import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'src/hooks';
import {
  addNewComment,
  updateComment,
  deleteCommentById
} from '../store/planner-slice-async-thunks';

export default function useProductComment() {
  const { id: scenarioId } = useParams();
  const appDispatch = useAppDispatch();

  const handleAddComment = (
    comment: string,
    parentId: number,
    childId: number
  ) =>
    appDispatch(
      addNewComment({
        params: {
          ppg_id: parentId,
          sku_id: childId,
          comment_text: comment
        },
        scenarioId: Number(scenarioId)
      })
    );

  const handleUpdateComment = (commentId: number, updatedComment: string) =>
    appDispatch(
      updateComment({
        commentId,
        commentText: updatedComment
      })
    );

  const handleDeleteComment = (commentId: number) =>
    appDispatch(deleteCommentById(commentId));

  return {
    handleAddComment,
    handleUpdateComment,
    handleDeleteComment
  };
}
